export const MY_PROFILE_SETTINGS_FETCH = 'MY_PROFILE_SETTINGS_FETCH'
export const MY_PROFILE_SETTINGS_FETCH_SUCCESS = 'MY_PROFILE_SETTINGS_FETCH_SUCCESS'
